export default __webpack_public_path__ + "static/media/68E0CAD9-EDC5-4819-9E2E-B3BE230E1F6D - Shubhayu Sinha.30fc4678.jpeg";